import clsx from "clsx";
import { useId } from "react";
import type { InputHTMLAttributes, ReactNode } from "react";

export interface CheckboxProps
  extends Omit<InputHTMLAttributes<HTMLInputElement>, "type" | "size"> {
  label?: ReactNode;
}

export function Checkbox({
  label,
  className,
  id,
  ...rest
}: CheckboxProps) {
  const autoId = useId();
  const inputId = id ?? autoId;

  const input = (
    <input
      id={inputId}
      type="checkbox"
      {...rest}
      className={clsx("check", className)}
    />
  );

  if (!label) return input;

  return (
    <label
      htmlFor={inputId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        cursor: rest.disabled ? "not-allowed" : "pointer",
      }}
    >
      {input}
      <span>{label}</span>
    </label>
  );
}
